import Form from '../../common/form';
import PropTypes from 'prop-types';
import Joi from 'joi';

class HelideckDropSummaryForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		shellWeight: Joi.number()
			.positive()
			.min(1)
			.required()
			.label('Dummy Shell Weight (Kg)'),
		numberOfNetTotal: Joi.number().required().label('Total Number Tested'),
		numberOfNetPassed: Joi.number().required().label('Total Number Passed'),
		numberOfNetFailed: Joi.number().required().label('Total Number Failed'),
		general: Joi.string().min(30).required().label('General Finding'),
		remarks: Joi.string().min(30).required().label('Remarks'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'shellWeight',
							label: 'Dummy Shell Weight (Kg)',
							placeholder: 'Enter Dummy Shell Weight',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'numberOfNetTotal',
							label: 'Total Number Tested',
							placeholder: 'Enter Total Number Tested',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'numberOfNetPassed',
							label: 'Total Number Passed',
							placeholder: 'Enter Total Number Passed',
							max: this.state.data.numberOfNetTotal,
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'numberOfNetFailed',
							label: 'Total Number Failed',
							placeholder: 'Enter Total Number Failed',
							max:
								this.state.data.numberOfNetTotal -
								this.state.data.numberOfNetPassed,
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderTextArea({
							name: 'general',
							label: 'General Finding',
							rows: '6',
							placeholder: 'Enter at least 30 characters',
						})}
					</div>

					<div className="col">
						{this.renderTextArea({
							name: 'remarks',
							label: 'Remarks',
							rows: '6',
							placeholder: 'Enter at least 30 characters',
						})}
					</div>
				</div>

				{this.renderButton('Proceed')}
			</form>
		);
	}
}

export default HelideckDropSummaryForm;
const initialData = {
	shellWeight: 0,
	numberOfNetTotal: 0,
	numberOfNetPassed: 0,
	numberOfNetFailed: 0,
	general: '',
	remarks: '',
};
